import React, {useEffect, useState, useMemo} from 'react';
import {Helmet} from 'react-helmet';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';

import {
  AddAdminContainer,
  SpreadSheetTableStyles,
  FullContainer,
} from './elements';
import {
  AddAdminFooter,
  AddAdminHeader,
  ManualForm,
  UploadSection,
  Accordion,
  UserTypeSelect,
} from './components';

import {
  ValidateLoader,
  SuccessMessage,
  NoUserAdded,
} from '../../../../components';

import CustomBox from '../../../../../../../../components/shared/CustomBox';

import {
  adminTeachersSelector,
  fetchBasicInfo,
} from '../../../../../../../../redux/adminTeacherSlice';
import {Table} from '../../../../../../../../components/common';

export const AddAdminTeacher = () => {
  const [addAdmins, setAddAdmins] = useState([]);
  const [spreadSheet, setSpreadSheet] = useState([]);
  const [fileImport, setImport] = useState(true);
  const [manual, setManual] = useState(false);
  const [upload, setUpload] = useState(null);
  const [onDrag, setOnDrag] = useState(false);
  const [formShow, setFormShow] = useState(true);
  const [btnShow, setBtnShow] = useState(true);
  const [nextShow, setNextShow] = useState(false);
  const [fileName, setFileName] = useState('');
  const [isAdminSpreadsheet, setIsAdminSpreadsheet] = useState(false);
  const [isTeacherSpreadsheet, setIsTeacherSpreadsheet] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const {
    alreadyExistRefId,
    alreadyExistEmail,
    duplicateData,
    emailPattern,
    validAdmin,
    organisation,
  } = useSelector(adminTeachersSelector);

  const [isValidating, setIsValidating] = useState(false);
  const [steps, setSteps] = useState(0);

  useEffect(() => {
    dispatch(fetchBasicInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (addAdmins.length === 0) {
      setBtnShow(true);
      setFormShow(true);
    }
  }, [addAdmins, spreadSheet]);

  // Spreadsheet flow mapping ,existing id checking and error mapping
  const spreadsheetcolumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'serial',
        className: 'serial',
      },
      {
        Header: 'ID',
        accessor: 'org_ref_id',
        className: 'ref-id',
      },
      {
        Header: 'First Name',
        accessor: 'first_name',
        className: 'first-name',
      },
      {
        Header: 'Last Name',
        accessor: 'last_name',
        className: 'last-name',
      },
      {
        Header: 'EMAIL',
        accessor: 'email',
        className: 'email',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      history,
      alreadyExistEmail,
      alreadyExistRefId,
      emailPattern,
      duplicateData,
    ],
  );

  // Add a serial number to each row and memoize the data.
  // spreadsheet map
  const spreadsheetdata = useMemo(
    () => [
      ...spreadSheet.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [spreadSheet],
  );

  // Error map in spreadsheet
  const emailPatternErrorData = useMemo(
    () => [
      ...emailPattern.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [emailPattern],
  );
  const duplicateDataError = useMemo(
    () => [
      ...duplicateData.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [duplicateData],
  );

  const referIDErrorData = useMemo(
    () => [
      ...alreadyExistRefId.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [alreadyExistRefId],
  );

  const emailErrorData = useMemo(
    () => [
      ...alreadyExistEmail.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [alreadyExistEmail],
  );

  return (
    <>
      <Helmet>
        <title>Add Users | JungleCat</title>
      </Helmet>
      <FullContainer>
        <AddAdminHeader />
        <AddAdminContainer>
          <div className="container-admin">
            <div className="adminheading d-flex justify-content-between  mb-4">
              <h2 style={{fontSize: '1.5rem'}}>
                Add admin / teacher to your organisation
              </h2>
            </div>
            <CustomBox padding="0.0625rem 1.25rem" className="custombox">
              {steps <= 1 ? (
                <div className="search-div">
                  <button
                    className={fileImport ? 'buttom link' : 'buttom'}
                    type="button"
                    id="addSpreadsheetBtn"
                    onClick={() => {
                      setImport(true);
                      setManual(false);
                      setSteps(0);
                      setIsAdminSpreadsheet(false);
                      setIsTeacherSpreadsheet(false);
                    }}
                  >
                    <p>Import From Spreadsheet</p>
                  </button>
                  <button
                    className={manual ? 'buttom link' : 'buttom'}
                    type="button"
                    id="addManuallyBtn"
                    onClick={() => {
                      setImport(false);
                      setManual(true);
                    }}
                  >
                    <p>Add Manually</p>
                  </button>
                  <div className="seperator-search mt-2" />
                </div>
              ) : null}
              {steps === 0 && fileImport ? (
                <UserTypeSelect
                  isAdminSpreadsheet={isAdminSpreadsheet}
                  isTeacherSpreadsheet={isTeacherSpreadsheet}
                  setIsTeacherSpreadsheet={setIsTeacherSpreadsheet}
                  setIsAdminSpreadsheet={setIsAdminSpreadsheet}
                />
              ) : null}

              {steps === 2 || isValidating ? (
                <div className="search-div-spread">
                  <p className="imported">Imported users from document</p>
                  <p className="imported-file">{fileName}</p>
                </div>
              ) : null}

              {manual ? (
                <ManualForm
                  manual={manual}
                  formShow={formShow}
                  btnShow={btnShow}
                  setFormShow={setFormShow}
                  setBtnShow={setBtnShow}
                  addAdmins={addAdmins}
                  setAddAdmins={setAddAdmins}
                />
              ) : (
                <div
                  className="inputfields"
                  style={steps === 2 ? {padding: '0rem 0rem 0rem 0rem'} : null}
                >
                  {steps === 1 && fileImport ? (
                    <UploadSection
                      steps={steps}
                      setUpload={setUpload}
                      upload={upload}
                      onDrag={onDrag}
                      setOnDrag={setOnDrag}
                      setSpreadSheet={setSpreadSheet}
                      setFileName={setFileName}
                      setNextShow={setNextShow}
                    />
                  ) : null}

                  {isValidating ? (
                    <ValidateLoader
                      title="Validating imported Users details"
                      subtitle="Please wait"
                    />
                  ) : null}
                  {!isValidating &&
                  steps === 3 &&
                  !alreadyExistRefId?.length &&
                  !emailPattern?.length &&
                  !duplicateData?.length &&
                  !alreadyExistEmail?.length ? (
                    <SuccessMessage
                      title={`${spreadSheet?.length} users added to
                    ${organisation?.or_orgname}`}
                      subtitle="All the users in the document has been added as
                    admin/teacher"
                    />
                  ) : null}
                  {!isValidating &&
                  steps === 3 &&
                  validAdmin?.length &&
                  (alreadyExistEmail?.length ||
                    duplicateData?.length ||
                    alreadyExistRefId?.length ||
                    emailPattern?.length) ? (
                    <Accordion
                      title={`${validAdmin.length}/${spreadSheet.length} users added to
                    ${organisation?.or_orgname}`}
                      subtitle=" Some of the users in the document cannot be added to the organisation"
                      emailPatternErrorData={emailPatternErrorData}
                      referIDErrorData={referIDErrorData}
                      emailErrorData={emailErrorData}
                      spreadsheetcolumns={spreadsheetcolumns}
                      alreadyExistRefId={alreadyExistRefId}
                      alreadyExistEmail={alreadyExistEmail}
                      emailPattern={emailPattern}
                      duplicateDataError={duplicateDataError}
                    />
                  ) : null}
                  {!isValidating &&
                  steps === 3 &&
                  !validAdmin?.length &&
                  (alreadyExistEmail?.length ||
                    alreadyExistRefId?.length ||
                    duplicateData?.length ||
                    emailPattern?.length) ? (
                    <NoUserAdded
                      title="No users added to this organisation"
                      subtitle="All the users already exist in organisation."
                    />
                  ) : null}
                </div>
              )}

              {!isValidating && spreadSheet?.length && steps === 2 ? (
                <SpreadSheetTableStyles>
                  <Table
                    columns={spreadsheetcolumns}
                    data={spreadsheetdata}
                    itemName="Users"
                    maxWidth="49.37rem"
                    isSortedBy
                    isWithoutHeader
                  />
                </SpreadSheetTableStyles>
              ) : null}
            </CustomBox>
          </div>
        </AddAdminContainer>
        <AddAdminFooter
          addAdmins={addAdmins}
          setAddAdmins={setAddAdmins}
          spreadSheet={spreadSheet}
          setSpreadSheet={setSpreadSheet}
          manual={manual}
          setUpload={setUpload}
          upload={upload}
          steps={steps}
          setSteps={setSteps}
          isAdminSpreadsheet={isAdminSpreadsheet}
          isTeacherSpreadsheet={isTeacherSpreadsheet}
          setIsTeacherSpreadsheet={setIsTeacherSpreadsheet}
          setIsAdminSpreadsheet={setIsAdminSpreadsheet}
          setIsValidating={setIsValidating}
          nextShow={nextShow}
          isValidating={isValidating}
          emailPattern={emailPattern}
        />
      </FullContainer>
    </>
  );
};
